/*
 * Until better understood: do not use
 * 
 * A functional replacement for switch statement
 * described: https://codeburst.io/alternative-to-javascripts-switch-statement-with-a-functional-twist-3f572787ba1c
 * 
    const matched = (x) => ({
        on: () => matched(x),
        otherwise: () => x,
    })

    const match = x => ({
        on: (pred: (x) => boolean, fn) => (pred(x) ? matched(fn(x)) : match(x)),
        otherwise: fn => fn(x),
    })
 */

import { FieldDataType } from '../enums/FieldDataType';
import { ClientField } from '../types/ClientField';
import { ConversationGridFiltersItem } from '../types/ConversationGridFiltersItem';

type DefaultGridFilter = Pick<
    ConversationGridFiltersItem,
    'operand' | 'value' | 'value2' | 'values'
>;
/**
 * matchFieldTypeToDefaultGridFilter
 *
 * @description
 * Matches a client field to an object that holds the default properties used to build a
 * ConversationGridFiltersItem object
 *
 * @param field
 */
export const matchFieldTypeToDefaultGridFilter = (field: ClientField): DefaultGridFilter => {
    switch (field.fieldType) {
        case FieldDataType.date:
            const currentDate = new Date().toISOString();
            return {
                operand: 'between',
                value: currentDate,
                value2: currentDate,
                values: [],
            };
        case FieldDataType.float:
        case FieldDataType.integer:
            return {
                operand: 'is',
                value: 0,
                value2: 1,
                values: [],
            };
        case FieldDataType.tags:
        case FieldDataType.users:
            return {
                operand: 'includes',
                value: '',
                value2: '',
                values: [],
            };
        case FieldDataType.enum:
            return {
                operand: 'includes',
                value: '',
                value2: '',
                values: [],
            };
        default:
            return {
                operand: 'contains',
                value: '',
                value2: '',
                values: [],
            };
    }
};
